export default [
  {
    path: '/simulacao',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    },
    view: 'Simulacao'
  },
  {
    path: '/termos-e-condicoes-gerais',
    dir: 'views/',
    meta: {
      requiresAuth: true
    },
    view: 'TermosCondicoesGerais',
  },
  {
    path: '/analise-proposta-2',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'AnaliseProposta2',
  },
  {
    path: '/comprovante',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Comprovante',
  },
  {
    path: '/informacoes-basicas-cpf',
    dir: 'views/',
    meta: {
      requiresAuth: true
    },
    view: 'InformacoesBasicasCPF',
  },
  {
    path: '/analise-proposta-3',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'AnaliseProposta3',
  },
  {
    path: '/validacao-documento',
    dir: 'views/',
    meta: {
      requiresAuth: true
    },
    view: 'ValidacaoDocumento',
  },
  {
    path: '/carregando',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Carregando',
  },
  {
    path: '/incluir-proposta',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador', 'Multiplo.Master'],
    },
    view: 'IncluirProposta',
  },
  {
    path: '/incluir-simulacao',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador', 'Multiplo.Master'],
    },
    view: 'IncluirSimulacao',
  },
  {
    path: '/analise-proposta-5',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador'],
    },
    view: 'AnaliseProposta5',
  },
  {
    path: '/credito-pessoal-objetivo',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador', 'Multiplo.Master'],
    },
    view: 'CreditoPessoalObjetivo',
  },
  {
    path: '/home',
    dir: 'views/',
    home: true,
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador', 'Multiplo.Master'],
    },
    view: 'Home',
  },
  {
    path: '/analise-proposta-1',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador', 'Multiplo.Master'],
    },
    view: 'AnaliseProposta1',
  },
  {
    path: '/apresentacao-1',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Apresentacao1',
  },
  {
    path: '/apresentacao-2',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Apresentacao2',
  },
  {
    path: '/limite-credito',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'LimiteCredito',
  },
  {
    path: '/apresentacao-3',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Apresentacao3',
  },
  {
    path: '/endereco-formulario',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'EnderecoFormulario',
  },
  {
    path: '/analise-proposta-4',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Operador', 'Multiplo.Master'],
    },
    view: 'AnaliseProposta4',
  },
  {
    path: '/erro',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'Erro',
  },
  {
    path: '/sem-proposta',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'SemProposta',
  },
  {
    path: '/cpf-erro',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'CpfErro',
  },
  {
    path: '/consulta-contrato',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'ConsultaContrato',
  },
  {
    path: '/informacoes-contato-email-input',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'InformacoesContatoEmailInput',
  },
  {
    path: '/endereco-cep',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'EnderecoCEP',
  },
  {
    path: '/informacoes-contato-email',
    dir: 'views/',
    meta: {
      requiresAuth: true
    },
    view: 'InformacoesContatoEmail',
  },
  {
    path: '/endereco-list',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'EnderecoList',
  },
  {
    path: '/endereco-home',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'EnderecoHome',
  },
  {
    path: '/bmp-money-plus',
    dir: 'views/',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master'],
    },
    view: 'BmpMoneyPlus',
  },
  {
    path: '/detalhes-proposta',
    dir: 'views/',
    meta: {
      requiresAuth: true
    },
    view: 'DetalhesProposta',
  },
  {
    path: '/',
    view: 'Logout',
    menu: false,
    dir: 'views/',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/auth/',
    dir: 'views/',
    view: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }
]
